import { useFormState, useWatch } from 'react-hook-form';
import { requiredOk } from '../../../../utils';

export const useParking = (control) => {
  const watchedValues = useWatch({
    control,
    name: ['isParkingFree', 'parkingCost', 'parkingCostType', 'parkingType'],
  });

  const { dirtyFields } = useFormState({ control });

  const formValues = {
    isParkingFree: watchedValues[0],
    parkingCost: watchedValues[1],
    parkingCostType: watchedValues[2],
    parkingType: watchedValues[3],
  };

  const parkingCostInformation =
    formValues.isParkingFree !== undefined &&
    (formValues.isParkingFree || (!!formValues.parkingCost && !!formValues.parkingCostType));

  const isValid = parkingCostInformation && !!formValues.parkingType;

  const anyParkingDirty = Boolean(
    dirtyFields.isParkingFree ||
      dirtyFields.parkingType ||
      dirtyFields.parkingCost ||
      dirtyFields.parkingCostType,
  );

  const canSave = requiredOk(anyParkingDirty, isValid);

  return {
    formValues,
    isValid,
    parkingCostInformation,
    canSave,
  };
};
